import axios from "./request";
import { getValidationContent } from "../utils";
const getUserInfo = () => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  return user || {};
};
export const ForumList = params => {
  const { page, title, sid, show_like } = params;
  const data = new FormData();
  const { id: uid } = getUserInfo();
  data.append("page", page);
  data.append("uid", uid);
  data.append("show_like", show_like || "");
  data.append("sid", sid || "");
  data.append("title", title || "");
  return axios.post("/topic_list_admin", data);
};
export const GetForumDetail = params => {
  const { id } = params;
  const { id: uid } = getUserInfo();
  const data = new FormData();
  data.append("id", id);
  data.append("type", "");
  data.append("uid", uid);
  return axios.post("/topic_operation", data);
};
export const UserGetFourmType = is_admin => {
  const data = new FormData();
  data.append("page", 1);
  data.append("name", "");
  data.append("num", -1);
  data.append("is_admin", is_admin || 2);
  return axios.post("/section", data);
};

export const UserGetFourmComments = params => {
  const data = new FormData();
  const { page, tid } = params;
  data.append("page", page);
  data.append("tid", tid);
  return axios.post("/comment", data);
};

export const PostUserComments = params => {
  const data = new FormData();
  const { tid, form, to } = params;
  const { id: uid, nickname } = getUserInfo();
  data.append("uid", uid);
  data.append("tid", tid);
  data.append("form", form);
  data.append("to", to);
  data.append("username", nickname);
  return axios.post("/comment_add", data);
};

export const DeleteUserComments = params => {
  const data = new FormData();
  const { id } = params;
  data.append("id", id);
  return axios.post("/comment_del", data);
};

export const UserSetLikeDislike = params => {
  const data = new FormData();
  const { tid, like } = params;
  const { id: uid } = getUserInfo();
  data.append("tid", tid);
  data.append("uid", uid);
  data.append("like", like);
  return axios.post("/like", data);
};

export const UserSetTopicShowHide = params => {
  const { id, status } = params;
  const data = new FormData();
  data.append("type", 2);
  data.append("id", id);
  data.append("status", status);
  data.append("title", "");
  data.append("content", "");
  return axios.post("/topic_operation", data);
};

export const UserDeleteTopic = params => {
  const { id } = params;
  const data = new FormData();
  data.append("type", 3);
  data.append("id", id);
  return axios.post("/topic_operation", data);
};

export const UserAddTopic = params => {
  const { id: uid } = getUserInfo();
  const { sid, content, status, title } = params;
  const data = new FormData();
  const {
    validateImgs,
    validateVideos,
    validateContent
  } = getValidationContent(content);
  data.append("type", 1);
  data.append("title", title);
  data.append("content", content);
  data.append("status", status);
  data.append("created_id", uid);
  data.append("sid", sid);
  data.append("validateImgs", validateImgs);
  data.append("validateVideos", validateVideos);
  data.append("validateContent", validateContent);
  return axios.post("/topic_operation", data);
};

export const UserEditTopic = params => {
  const { sid, content, status, id, title } = params;
  const data = new FormData();
  const {
    validateImgs,
    validateVideos,
    validateContent
  } = getValidationContent(content);
  data.append("type", 2);
  data.append("title", title);
  data.append("id", id);
  data.append("content", content);
  data.append("sid", sid);
  data.append("status", status);
  data.append("validateImgs", validateImgs);
  data.append("validateVideos", validateVideos);
  data.append("validateContent", validateContent);
  return axios.post("/topic_operation", data);
};



// WEBPACK FOOTER //
// ./src/request/forum.js